// eslint-disable-next-line import/no-extraneous-dependencies
import { useParams } from 'react-router-dom';

import { useGetMatterDetailsQuery } from '../services/api';

const useMatterSelection = () => {
  const { matter_id } = useParams();

  const {
    data: selectedMatterData,
    error: selectedMatterError,
    isLoading: selectedMatterLoading,
    refetch: refetchMatterDetails,
  } = useGetMatterDetailsQuery(matter_id || '', {
    skip: !matter_id,
    pollingInterval: 1000 * 60 * 5, // 5 minutes
  });

  return {
    selectedMatterData,
    selectedMatterError,
    selectedMatterLoading,
    refetchMatterDetails,
    matter_id,
  };
};

export default useMatterSelection;
